import { Button, Layout } from "antd";
import { ReactComponent as History } from "assets/icons/history.svg";
const { Header } = Layout;

const DefaultHeader = ({ handleNavigate, title, location }) => {
  const renderHomeLogo = () => {
    return (
      location.pathname === "/home" && (
        <img
          src={"https://cdn.firouzeh.com/public/logo-firouzeh-without-typo.svg"}
          alt="logo"
          className="ml-2"
        />
      )
    );
  };

  const renderHistory = () => {
    return (
      location.pathname === "/home" && (
        <Button
          onClick={() => handleNavigate()}
          icon={<History className="w-6 h-6" />}
          className="icon-button"
        />
      )
    );
  };

  return (
    <Header
      className={`fixed h-auto px-5 w-full max-w-3xl mx-auto bg-white  py-2 sm:mt-5 sm:shadow-sm  sm:rounded-lg z-40 ${
        location.pathname !== "/profile" ? "block" : "hidden sm:block"
      }`}
    >
      <div
        className={`flex ${
          location.pathname === "/home" ? "justify-between" : "justify-center"
        } items-center`}
      >
        <div className="body-16px-medium flex items-center">
          {renderHomeLogo()}
          <span className="text-gray-0 ">{title}</span>
        </div>
        {renderHistory()}
      </div>
    </Header>
  );
};

export default DefaultHeader;
